module.exports = __webpack_public_path__ + "static/caddy-exclusive-1c7dc78c7e657ecd7637d5b2ba5937e2.png";